import React, { useEffect, useState } from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as CaretLeft } from "assets/icons/caret-left.svg";
import { ReactComponent as CaretRight } from "assets/icons/caret-right.svg";
import { PaginationItems, PaginationRoot } from "components/ui/pagination";
import { handleGetMaxPage } from "utils";
import { ONE } from "utils/constants";

import { Button } from "ui/button";

import {
  DEFAULT_ROWS_PER_PAGE_OPTIONS,
  insertNewOptionInCorrectSortedPosition,
} from "./pagination-start";
import { IRowsPerPageOption } from "./pagination-start/types";
import { ICompliancePaginationProps } from "./types";

export const CompliancePagination = (props: ICompliancePaginationProps) => {
  const { paginationParams, updatePaginationParams, paginationData } = props;
  const { page, limit } = paginationParams;
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState<
    IRowsPerPageOption[]
  >(DEFAULT_ROWS_PER_PAGE_OPTIONS);
  const count = paginationData.totalDocs;
  const maxPage = handleGetMaxPage(count, limit);

  const handleDecrement = () => {
    if (page <= ONE) return;
    const newPage = page - ONE;
    updatePaginationParams({
      page: newPage,
      limit,
    });
  };

  const handleIncrement = () => {
    if (page >= maxPage) return;
    const newPage = page + ONE;
    updatePaginationParams({
      page: newPage,
      limit,
    });
  };

  useEffect(() => {
    const isLimitNotInCurrentOptions = rowsPerPageOptions.find(
      ({ value }) => value === limit
    );
    if (!isLimitNotInCurrentOptions) {
      const updatedRowPerPageOptions = insertNewOptionInCorrectSortedPosition(
        rowsPerPageOptions,
        limit
      );
      setRowsPerPageOptions(updatedRowPerPageOptions);
    }
  }, [limit]);

  return (
    <Box
      className="flex items-center gap-1 h-8"
      css={{
        fontSize: "12px",
        color: "#807F94",

        "& > [data-scope='pagination']": {
          color: "#807F94",
          fontWeight: 600,
          fontSize: "12px",
          lineHeight: "16px",
        },
        "& > [data-scope='pagination'][data-selected]": {
          backgroundColor: "#EEEEF1",
          color: "#09090B",
          width: "32px",
          height: "32px",
          minWidth: "32px",
          borderRadius: "6px !important",
        },
        "& > [data-selected]:hover": {
          backgroundColor: "#EEEEF1",
          color: "#09090B",
        },
      }}
    >
      <Button
        border="1px solid #E2E8F0"
        borderRadius="6px"
        variant="outline"
        aria-label="Previous Page"
        textColor="#807F94"
        fontWeight={500}
        onClick={handleDecrement}
        disabled={page <= ONE}
        className="w-[32px] min-w-[32px] h-[32px] cursor-pointer"
        style={{
          padding: "12px 8px",
          borderRadius: "6px",
        }}
      >
        <CaretLeft className="w-[16px] h-[16px]" />
      </Button>
      <PaginationRoot
        siblingCount={1}
        count={count}
        pageSize={limit}
        page={page}
        onPageChange={(evt) => {
          const { page } = evt;
          updatePaginationParams({ page, limit });
        }}
        asChild
      >
        <PaginationItems />
      </PaginationRoot>
      <Button
        border="1px solid #E2E8F0"
        borderRadius="6px"
        variant="outline"
        aria-label="Next Page"
        textColor="#807F94"
        fontWeight={500}
        onClick={handleIncrement}
        disabled={page >= maxPage}
        className="w-[32px] min-w-[32px] h-[32px] cursor-pointer"
        style={{
          padding: "12px 8px",
          borderRadius: "6px",
        }}
      >
        <CaretRight className="w-[16px] h-[16px]" />
      </Button>
    </Box>
  );
};
